import React from 'react';
import { Card, EmptyState } from '../components/ui';

// Foundation only (spec section 53) -- no file sync/upload implemented yet.
export function FilesScreen() {
  return (
    <div style={{ padding: 'var(--ozira-space-lg)' }}>
      <Card>
        <EmptyState title="No files yet" description="File attachment and browsing land in a later phase." />
      </Card>
    </div>
  );
}
